import { Component } from 'react'
import { Link } from 'react-router-dom'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../insfrastructure/utils/form-validators'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { login, TokenParams } from '../../../../insfrastructure/services/auth'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import ResponseModal from '../../../components/response-modal'
import Toast from '../../../components/toast'
import { SubmitBtn } from '../../../components/submit'
import { Input } from '../../../components/input'
import loginImg from '../../../../assets/images/login.png'
import logoImg from '../../../../assets/images/logo-white.png'
import './styles.sass'


class Login extends Component<RouterProps> {
    state: any = {
        form: {
            username: '',
            password:  '',
            remember_me: false
        },
        formErrors: {},
        loading: false,
        sended: false,
        responseData: null,
        showOffersToast: false
    }

    componentDidMount() {
        // Verificar se o usuário foi redirecionado da rota /offers
        const redirectFromOffers = sessionStorage.getItem('redirect_from_offers');
        if (redirectFromOffers === 'true') {
            // Exibir toast
            setTimeout(() => {
                this.setState({ showOffersToast: true });
            }, 500);
        }
    }

    onSubmit = async () => {
        if(this.state.loading) return;

        const errors = formatErrors({
            username: [emptyField(this.state.form.username, 'string')],
            password: [emptyField(this.state.form.password, 'string')]
        });

        this.setState({ formErrors: errors });

        if(errorsLength(errors) > 0) return;

        this.setState({ loading: true });

        try {
            const response = await login(this.state.form);

            const parsedJWT: TokenParams = parseJwt(response.data.access);

            localStorage.setItem('auth_token', response.data.access);
            localStorage.setItem('user_id', parsedJWT.user_id+'');
            localStorage.setItem('legacy_password_login', parsedJWT.legacy_password_login+'');
            
            let route = '';
            if (parsedJWT.profiles.includes('candidate')) {
                localStorage.setItem('candidate_id', parsedJWT.candidate_id+'');
                route = '/profile/candidate/person';
            } else {
                localStorage.setItem('manager_id', parsedJWT.manager_id+'');

                if (parsedJWT.company_id) {
                   localStorage.setItem('company_id', parsedJWT.company_id);   
                };

                if (parsedJWT.em_unit_id) {
                   localStorage.setItem('em_unit_id', parsedJWT.em_unit_id+'');   
                };

                route = '/offers';
            };
            
            setTimeout(() => {
                this.setState({ sended: true, loading: false });
                
                // Limpar flag de redirecionamento após login bem-sucedido
                sessionStorage.removeItem('redirect_from_offers');
                
                if (localStorage.getItem('legacy_password_login') === 'true') {
                    route = '/reset-password';
                };

                this.props.navigate(route);
            });
        } catch (error) {
            let responseData = {
                type: 'error',
                title: 'Login inválido',
                text: () => <></>
            };
        
            this.setState({ loading: false, responseData });
        }
    }

    onCloseOffersToast = () => {
        this.setState({ showOffersToast: false });
        // Limpar flag quando o toast for fechado
        sessionStorage.removeItem('redirect_from_offers');
    }

    render() {
        return (
            <div className='login unlogged-page'>
                <div className='content'>
                    <div className='block'>
                        {window.innerWidth > 1000 &&
                        <div className='img-container'>
                            <img src={loginImg} alt='login-img' />
                        </div>}
                        <div className='block-content'>
                            <div className='text'>
                                <h1>Bem vindo de volta!</h1>
                                <div>
                                    <p>Entre para continuar no</p>
                                    <img className='logo' src={logoImg} alt='logo' />
                                </div>
                            </div>
                            <div className='form'>
                                <Input
                                name='username'
                                label='Email'
                                placeholder='Insira seu email'
                                onChange={e => this.setState({ form: { ...this.state.form, username: e } })}/>
                                <ErrorMessage errors={this.state.formErrors['username']} />
                                <Input
                                name='password'
                                label='Senha'
                                type='password'
                                placeholder='Insira sua senha'
                                onChange={e => this.setState({ form: { ...this.state.form, password: e } })}/>
                                <ErrorMessage errors={this.state.formErrors['password']} />
                                <div className='extra-questions'>
                                    <div className='remember-me' onClick={() => this.setState({ form: { ...this.state.form, remember_me: !this.state.form.remember_me } })}>
                                        <input type='checkbox' checked={this.state.form.remember_me} />
                                        <p>Lembrar me</p>
                                    </div>
                                    <Link to='/reset-password'><p>Esqueceu a senha?</p></Link>
                                </div>
                            </div>
                            <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
                            <div className='bottom-text'>
                                <p>Ainda não possui uma conta?</p>
                                <Link to='/sign-up'><b>Cadastrar-se</b></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => this.setState({ responseData: null })} />
                
                <Toast
                show={this.state.showOffersToast}
                message="É necessário fazer login para ver vagas e se candidatar"
                type="info"
                onClose={this.onCloseOffersToast}
                autoClose={true}
                duration={5000} />
            </div>
        )
    }
}

export default withRouter(Login);